import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepTwoExtraGroups.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getGroupsData = createSelector(
  (state) => state.memoryStepTwoExtraGroups.data.memoryStepTwoExtraGroups,
  (groups = []) => groups
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepTwoExtraGroups.data.currency,
  (currency = {}) => currency
);

export default {
  getCurrencyData,
  getGroupsData,
  getHasLoaded,
};
